export default {
  schedule: {
    type: Object,
    default: () => {}
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/components/schedule/resources/props.js